import {
  Avatar,
  type AvatarProps,
  Text,
  Flex,
  TextSize,
  type TextProps,
} from '@frontend/components';

export type AvatarWithNameProps = AvatarProps & {
  textSize?: TextSize;
  textEllipsis?: boolean;
  textProps?: TextProps;
  isDeleted?: boolean;
};

export const AvatarWithName = ({
  name,
  size = 'sm',
  textSize = 'md',
  textEllipsis = false,
  textProps,
  isDeleted = false,
  backgroundColor,
  ...avatarRestProps
}: AvatarWithNameProps) => {
  const additionalProps = textEllipsis
    ? {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }
    : {};
  const deletedTextProps = isDeleted
    ? {
        color: 'feature.secondary',
        fontStyle: 'italic',
      }
    : {};
  return (
    <Flex alignItems="center" gap={0.5}>
      <Avatar
        name={isDeleted ? undefined : name}
        size={size}
        backgroundColor={isDeleted ? 'feature.placeholder' : backgroundColor}
        {...avatarRestProps}
      />
      <Text
        as="span"
        size={textSize}
        color={name == null ? 'feature.secondary' : 'feature.primary'}
        {...additionalProps}
        {...deletedTextProps}
        {...textProps}
      >
        {name == null ? 'Unassigned' : isDeleted ? `${name} (deleted)` : name}
      </Text>
    </Flex>
  );
};
